export default function filterAddedItems(kit, addedItems) {
  const excludeItems = JSON.parse(addedItems)
  const fitteredItems = kit.filter(
    (product) => !excludeItems.includes(product.id),
  )

  return fitteredItems
}
